import { useContext } from 'react';
import { InstanceIdContext } from './InstanceIdContext';

export const useInstanceId = (): string => {
  const context = useContext(InstanceIdContext);
  if (context === undefined) {
    return 'default';
  }
  return context.instanceId;
};